/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_Center_StripInputs */

const en_ocr_crop_center_strip = /** @type {(inputs: Ocr_Crop_Center_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center Strip`)
};

const fr_ocr_crop_center_strip = /** @type {(inputs: Ocr_Crop_Center_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bande centrale`)
};

const de_ocr_crop_center_strip = /** @type {(inputs: Ocr_Crop_Center_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittelstreifen`)
};

const it_ocr_crop_center_strip = /** @type {(inputs: Ocr_Crop_Center_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Striscia centrale`)
};

const ru_ocr_crop_center_strip = /** @type {(inputs: Ocr_Crop_Center_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Центральная полоса`)
};

const es_ocr_crop_center_strip = /** @type {(inputs: Ocr_Crop_Center_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franja central`)
};

const zh_cn2_ocr_crop_center_strip = /** @type {(inputs: Ocr_Crop_Center_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中心条纹`)
};

const ja_ocr_crop_center_strip = /** @type {(inputs: Ocr_Crop_Center_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`センターストリップ`)
};

const hi_ocr_crop_center_strip = /** @type {(inputs: Ocr_Crop_Center_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केंद्र पट्टी`)
};

const pt_pt2_ocr_crop_center_strip = /** @type {(inputs: Ocr_Crop_Center_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faixa central`)
};

/**
* | output |
* | --- |
* | "Center Strip" |
*
* @param {Ocr_Crop_Center_StripInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_center_strip = /** @type {((inputs?: Ocr_Crop_Center_StripInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_Center_StripInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_crop_center_strip(inputs)
	if (locale === "de") return de_ocr_crop_center_strip(inputs)
	if (locale === "it") return it_ocr_crop_center_strip(inputs)
	if (locale === "ru") return ru_ocr_crop_center_strip(inputs)
	if (locale === "es") return es_ocr_crop_center_strip(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_crop_center_strip(inputs)
	if (locale === "ja") return ja_ocr_crop_center_strip(inputs)
	if (locale === "hi") return hi_ocr_crop_center_strip(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_crop_center_strip(inputs)
	return en_ocr_crop_center_strip(inputs)
});